import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "key"];
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { withBreadcrumb } from '@atlassian/commerce-telemetry/dispatch-hooks';
import { CC_ERROR_BOUNDARY } from '../../../common/constants/breadcrumb-names';
import { useCreditCardRetry } from '../../../controllers/hooks/use-credit-card-retry';
import { messages } from './messages';
var ErrorCreditCardWithoutBreadcrumb = function ErrorCreditCardWithoutBreadcrumb() {
  var intl = useIntl();
  var retry = useCreditCardRetry();
  var title = intl.formatMessage(messages.title);
  var retryText = intl.formatMessage(messages.retry);
  var contactSupportText = intl.formatMessage(messages.contactSupport);
  return (
    /*#__PURE__*/
    // div is required to unbound SectionMessage from 100% height style from the parent
    React.createElement("div", null, /*#__PURE__*/React.createElement(SectionMessage, {
      appearance: "error",
      title: title,
      actions: [{
        key: 'retry',
        onClick: retry,
        text: retryText
      }, {
        key: 'support',
        href: 'https://support.atlassian.com/',
        text: contactSupportText
      }].map(function (_ref) {
        var text = _ref.text,
          key = _ref.key,
          restAction = _objectWithoutProperties(_ref, _excluded);
        return /*#__PURE__*/React.createElement(SectionMessageAction, _extends({}, restAction, {
          key: key
        }), text);
      })
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.content)))
  );
};
export var ErrorCreditCard = withBreadcrumb(ErrorCreditCardWithoutBreadcrumb, CC_ERROR_BOUNDARY);